import React, { useState, useEffect } from 'react';
import MaterialTable from 'material-table';
import { useSelector } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { language } from 'config';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

export default function Earningreports() {

  const columns = [
   // { title: language.year, field: 'year' },
    { title: language.uni_date, field: 'dated' },
   // { title: language.months, field: 'monthsName' },
    { title: language.Gross_trip_cost, field: 'tripCost' },
    { title: language.trip_cost_driver_share, field: 'rideCost' },
    { title: language.convenience_fee, field: 'convenienceFee' },

    { title: language.Discounts, field: 'discountAmount' },
    { title: language.Profit, field: 'profit', render: rowData => rowData.convenienceFee - rowData.discountAmount, editable: 'never' },

  ];

  const [data, setData] = useState([]);
  const earningreportsdata = useSelector(state => state.earningreportsdata);

  useEffect(() => {
    if (earningreportsdata.Earningreportss) {
      setData(earningreportsdata.Earningreportss);
    }
  }, [earningreportsdata.Earningreportss]);
  //const obj = JSON.stringify(data);

  

  return (
    earningreportsdata.loading ? <CircularLoading /> :
      <div>
        <MaterialTable
          title={language.earning_reports}
          columns={columns}
          data={data}
          style={{
            border: "2px solid gray",
            maxWidth: "1450px",
            overflow: "scroll",
            marginTop: "10px",
            marginLeft: "20px",
          }}
          options={{
            exportButton: true,
            draggable: true,
            grouping: true,
            tableLayout: "auto",
            headerStyle: {
              backgroundColor: '#144216',
              color: '#FFF'
            },
          }}

        />
        <br />
         
        <div class="text-center">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="inputGroupSelect01">choose Year</label>
            </div>
            <select class="custom-select" id="inputGroupSelect01">
              <option selected>2021</option>
              <option>2022</option>
              <option>2023</option>
              <option>2024</option>
              <option>2025</option>
              <option>2026</option>
              <option>2027</option>
              <option>2028</option>              
            </select>
          </div>
          <p class="lead h4 text-center">
          <strong>BarChart of 2021's Earnings</strong>
        </p>
        <br/>
          <BarChart
            width={700}
            height={400}
            data={data}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="monthsName" />
            <YAxis />
            <Tooltip />
            {/* <Legend layout="vertical" verticalAlign="middle" align="center" /> */}
            <Legend layout="horizontal" verticalAlign="bottom" align="center" wrapperStyle={{ top: 45, left: 0 }} />
            <Bar dataKey="driverShare" fill="#0d133b" />
            <Bar dataKey="tripCost" fill="#2e7306" />
            <Bar dataKey="myEarning" fill="#800874" />

          </BarChart>
        </div>

      </div>
  );
}
